"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var banqueSelectPopinModal = {
  controller: "banqueSelectPopinController",
  template: require("./banqueSelectPopin.html"),
  options: {
    width: 800
  }
};
ngModule.factory("banqueSelectPopin", function ($modal) {
  return {
    open: function open() {
      return $modal.open(_objectSpread({}, banqueSelectPopinModal));
    }
  };
});
ngModule.controller("banqueSelectPopinController", function ($scope, contrepartieService, banqueSearchMatcher) {
  var ctrl = this;
  ctrl.searchTerm = "";
  ctrl.banques = [];
  contrepartieService.getContreparties().then(function (banques) {
    ctrl.banques = banques;
    refreshResults();
  });
  $scope.selectBanque = function (banque) {
    $scope.$close(banque);
  };
  $scope.$watch(function () {
    return ctrl.searchTerm;
  }, function () {
    return refreshResults();
  });
  var refreshResults = function refreshResults() {
    var filtered = _.filter(ctrl.banques, function (b) {
      return banqueSearchMatcher(ctrl.searchTerm, b);
    });
    var groups = [];
    _.each(filtered, function (option) {
      var optGroupByValue = option.groupLabel;
      var group = _.find(groups, {
        value: optGroupByValue
      });
      if (group == null) {
        group = {
          value: optGroupByValue,
          options: []
        };
        groups.push(group);
      }
      group.options.push(option);
    });
    ctrl.results = groups;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/banques/banqueSelectPopin.js
// module id = 2992
// module chunks = 13